import { render } from '@react-email/render';
import { SES } from '@aws-sdk/client-ses';
import { Email } from './EmailTemplate';
import config from "../amplifyconfiguration.json";
import { DateTime } from 'aws-sdk/clients/devicefarm';
import { GetLogoURL, GetSetting, GetSettingBool, GetSettings, GetSettingsThatStartWith } from 'services/GetInvoiceData';

import { SQW_Log, DebugLevel } from "services/Logging";
import { GetAWSCredentials } from 'services/GetInvoiceData';
import { send } from 'process';
import { WebInventoryItem } from 'components/StoreItems';

const defaultConfirmationURL = "https://prism-web-images-prod.s3.amazonaws.com/emailtemplates/DefaultEmailConfirmationTemplate.html";
const defaultServiceConfirmationURL = "https://prism-web-images-prod.s3.amazonaws.com/emailtemplates/DefaultEmailConfirmationServiceTemplate.html";

const emailHtml = `<!DOCTYPE html>
<html>
<body>

<h1>Your order</h1>
<p>Your order date is [[ORD_DATE]]</p>

</body>
</html>`;

const params = {
    Source: 'test@servquestweb.com',
    Destination: {
        ToAddresses: ['dgikow@prismvs.com'],
    },
    Message: {
        Body: {
            Html: {
                Charset: 'UTF-8',
                Data: emailHtml,
            },
        },
        Subject: {
            Charset: 'UTF-8',
            Data: 'This is a test email',
        },
    },
};

interface CompanyInfo {
    confirmationEmailURL: string;
    confirmationEmailServiceURL: string;
    confirmationEmailSubject: string;
    companyEmail: string;
    companyCopyEmail: string;
    companyDisplayEmail: string;
    companyPhone: string;
    companyLogo: string;
    companyName: string;
    doNotSendConfirmation: boolean;
    confirmationEmailURLCompanyCopy: string;
    confirmationEmailServiceURLCompanyCopy: string;
    sendCompanyCopy: boolean;
};

async function GetCompanyInfo() {
    var ci = {} as CompanyInfo;

    ci.doNotSendConfirmation = await GetSettingBool("companyconfirmationemaildonotsend", false);
    ci.sendCompanyCopy = await GetSettingBool("SendEmailConfirmationsToClient", false);
    
    ci.confirmationEmailURL = (await GetSetting("companyconfirmationemailurl", "")).toLowerCase();
    ci.confirmationEmailServiceURL = (await GetSetting("companyconfirmationemailserviceurl", "")).toLowerCase();
    ci.confirmationEmailURLCompanyCopy = (await GetSetting("companyconfirmationemailurlcompanycopy", "")).toLowerCase();
    ci.confirmationEmailServiceURLCompanyCopy = (await GetSetting("companyconfirmationemailserviceurlcompanycopy", "")).toLowerCase();
    ci.confirmationEmailSubject = await GetSetting("companyconfirmationemailsubject", "Order Confirmation");
    ci.companyEmail = await GetSetting("companyconfirmationemailaddress", "orders@servquestweb.com");
    ci.companyCopyEmail = await GetSetting("EmailConfirmationsToClientAddress", "orders@servquestweb.com");
    ci.companyPhone = await GetSetting("companyconfirmationphone", "");
    ci.companyName = await GetSetting("companyconfirmationname", "");
    ci.companyDisplayEmail = await GetSetting("companyconfirmationdisplayemailaddress", "");
    ci.companyLogo = await GetLogoURL();
    if (ci.confirmationEmailURL === "")
        ci.confirmationEmailURL = defaultConfirmationURL;

    if(ci.confirmationEmailURLCompanyCopy === "")
        ci.confirmationEmailURLCompanyCopy = ci.confirmationEmailURL;
    if(ci.confirmationEmailServiceURLCompanyCopy === "")
        ci.confirmationEmailServiceURLCompanyCopy = ci.confirmationEmailServiceURL;

    if(ci.companyCopyEmail === "" ) {
        ci.companyCopyEmail = ci.companyEmail;
    }

    SQW_Log(DebugLevel.LOG, "Company Info before emailing: ", ci);

    return ci;
}


export async function SendTestEmail() {
    //SendEmailConfirmation("dgikow@prismvs.com", "1/1/2024", "444444444");
    //SendEmailConfirmation("dgikow@prismvs.com", "test@servquestweb.com", "Test of send email from aws", emailHtml, new Date());
    /*var em = await ses.sendEmail(params);
    if (em) {
        SQW_Log(DebugLevel.LOG, "Emailed", em);
        SQW_Log(DebugLevel.LOG, "Emailed 2", em.MessageId);
    }*/
}

/*export async function SendEmailConfirmationURL(toEmail: string, fromEmail: string, subject: string, htmlURL: string, orderDate: DateTime) {
    //const htmlMessage = render({htmlURL});
    if (htmlURL === "")
        htmlURL = defaultConfirmationURL;

    const response = await fetch(htmlURL);

    if (response) {
        const htmlMessage = await response.text();
        SendEmailConfirmation(toEmail, fromEmail, subject, htmlMessage, orderDate, "44444444");
    }


}*/

async function GetMessage(emailURL: string) {
    const response = await fetch(emailURL);

    if (response) {
        const htmlMessage = await response.text();
        return htmlMessage;
    }

    return "";
}

function GetLineItems(orderCartItems: WebInventoryItem[]) {
    let lineItems = "<ul>";
    for (const item of orderCartItems) {
        lineItems += `<li>${item.citemno} - ${item.cdescshort} - Qty: ${item.nqty} - Price: ${item.nprice}</li>`;
    }
    lineItems += "</ul>";
    return lineItems;
}   

export async function SendEmailConfirmationOrder(toEmail: string, orderDate: string, orderNumber: string, customerNumber: string, orderCartItems: WebInventoryItem[]) {
    var ci = await GetCompanyInfo();
    if (ci.doNotSendConfirmation)
        return;

    const emailURL = ci.confirmationEmailURL;
   
    const variables = { "ORD_DATE": orderDate, "ORDER_NUMBER": orderNumber, "CUSTOMER_NUMBER": customerNumber, "ORDER_ITEMS": GetLineItems(orderCartItems) };

    SendEmailConfirmationOrderAndService(toEmail, emailURL, ci.confirmationEmailURLCompanyCopy, orderDate, orderNumber, ci, "Delivery", variables);
}

export async function SendEmailConfirmationService(toEmail: string, orderDate: string, orderNumber: string, customerNumber: string, message: string) {
    var ci = await GetCompanyInfo();
    if (ci.doNotSendConfirmation)
        return;

    const emailURL = ci.confirmationEmailServiceURL;

    const variables = { "ORD_DATE": orderDate, "ORDER_NUMBER": orderNumber, "CUSTOMER_NUMBER": customerNumber, "SERVICE_REQUEST_MESSAGE": message };

    SendEmailConfirmationOrderAndService(toEmail, emailURL, ci.confirmationEmailServiceURLCompanyCopy, orderDate, orderNumber, ci, "Service", variables);
}

async function buildEmailParams(toEmail: string, fromEmail: string, subject: string, htmlMessage: string, variables: object, ci: CompanyInfo) {
     const logo = ci.companyLogo;
    const companyEmail = ci.companyEmail;
    const companyDisplayEmail = ci.companyDisplayEmail;
    const companyPhone = ci.companyPhone;
    const companyName = ci.companyName;

    // check if variables has keys and loop through them to replace in htmlMessage
    for (const [key, value] of Object.entries(variables)) {
        const placeholder = `[[${key}]]`;
        htmlMessage = htmlMessage.replaceAll(placeholder, value as string);
    }

    var settings = await GetSettingsThatStartWith("companyconfirmation");
    for (const setting of settings) {
        const placeholder = `[[${setting.name}]]`;
        htmlMessage = htmlMessage.replaceAll(placeholder, setting.value);
    }

    htmlMessage = htmlMessage.replaceAll("[[LOGO]]", logo);
    htmlMessage = htmlMessage.replaceAll("[[COMPANY_EMAIL]]", companyDisplayEmail);
    htmlMessage = htmlMessage.replaceAll("[[COMPANY_PHONE]]", companyPhone);
    htmlMessage = htmlMessage.replaceAll("[[COMPANY_NAME]]", companyName);


    const emParams = {
        Source: fromEmail,
        Destination: {
            ToAddresses: [toEmail],
        },
        Message: {
            Body: {
                Html: {
                    Charset: 'UTF-8',
                    Data: htmlMessage,
                },
            },
            Subject: {
                Charset: 'UTF-8',
                Data: subject,
            },
        },
    };
    return emParams;
}


export async function SendEmailConfirmationOrderAndService(toEmail: string, emailURL: string, companyCopyEmailURL: string, orderDate: string, orderNumber: string, ci: CompanyInfo, type: string, variables: object = {}) {

    SQW_Log(DebugLevel.LOG, "Preparing to send " + type + " email to: ", toEmail);
    
    if (ci.doNotSendConfirmation) {
        SQW_Log(DebugLevel.LOG, "Email sending is disabled by company settings.");
        return;
    }

    SQW_Log(DebugLevel.LOG, "Getting email from URL: ", emailURL);

    var htmlMessage = await GetMessage(emailURL);

    if (htmlMessage === "")
        return;

    let sendCompanyCopy = ci.sendCompanyCopy ?? false;
    
    var companyHtmlMessage = "";

    if (companyCopyEmailURL !== "" && sendCompanyCopy) {
        SQW_Log(DebugLevel.LOG, "Getting company copy email from URL: ", companyCopyEmailURL);  
        companyHtmlMessage = await GetMessage(companyCopyEmailURL);
        SQW_Log(DebugLevel.LOG, "Got company copy email message: ", companyHtmlMessage);
        if (companyHtmlMessage === "") {
            sendCompanyCopy = false;
        }
    }

    var emParams = await buildEmailParams(toEmail, ci.companyEmail, ci.confirmationEmailSubject, htmlMessage, variables, ci);
    
    SQW_Log(DebugLevel.INFO, "Sending email: ", emParams);

    const credentials = await GetAWSCredentials();
    if (!credentials) {
        SQW_Log(DebugLevel.ERROR, "AWS credentials not available, cannot send email.");
        return;
    }
    const ses = new SES({ region: "us-east-1", credentials: credentials });
    var em = await ses.sendEmail(emParams);
    if (em) {
        SQW_Log(DebugLevel.LOG, "Sent Email", em);
    }

    if (sendCompanyCopy) {
        var companyEmParams = await buildEmailParams(ci.companyCopyEmail, ci.companyEmail, type + " order placed on website", companyHtmlMessage, variables, ci);

        SQW_Log(DebugLevel.INFO, "Sending company copy email: ", companyEmParams);

        var em2 = await ses.sendEmail(companyEmParams);
        if (em2) {
            SQW_Log(DebugLevel.LOG, "Sent Company Copy Email", em2);
        }
    }

}

export { }